import axios from 'axios';
import { QueryClient } from '@tanstack/react-query';

import { notify } from 'src/utils/helper';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // You can tweak this per query
    },
    mutations: {
      onError: (err) => {
        notify('error', err?.response.data);
      },
    },
  },
});
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

// Reusable interceptor setup
const setupInterceptors = (instance) => {
  instance.interceptors.response.use(
    (res) => res,
    (error) => {
      const message = error?.response?.data?.message || error.message || 'Something went wrong';
      // showGlobalSnackbar(message, 'error');

      if (error.response?.status === 401) {
        // logoutUser(); // redirect or clear localStorage
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// Define different Axios instances
export const authClient = setupInterceptors(axios.create({ baseURL: CONFIG.baseURL }));

export const orderClient = setupInterceptors(axios.create({ baseURL: CONFIG.orderURL }));

export const paymentClient = setupInterceptors(axios.create({ baseURL: CONFIG.paymentsURL }));

export const userClient = setupInterceptors(axios.create({ baseURL: CONFIG.userURL }));

export const restClient = setupInterceptors(axios.create({ baseURL: CONFIG.restURL }));

export const serviceClient = setupInterceptors(axios.create({ baseURL: CONFIG.urlForLocalImage }));

export const trackerClient = setupInterceptors(
  axios.create({ baseURL: CONFIG.currentLocationUrl })
);

export const zohoClient = setupInterceptors(axios.create({ baseURL: CONFIG.whatsAppUrl }));

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',

  auth: {
    me: '/api/auth/me',
    login: '/login',
    signIn: '/api/auth/sign-in',
    signUp: '/api/auth/sign-up',
  },

  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },

  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },

  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};

export default axios;
